<div class="page">
  <HeaderBlock/>
  <Intro/>
  <StackingResults
    :totalStakedInCgu="totalStakedInCgu"
    :totalStakedInUsdt="totalStakedInUsdt"
    :totalStakedInUsdtFormatted="totalStakedInUsdtFormatted"
    :totalStakedInCguFormatted="totalStakedInCguFormatted"
    :stakedUsd="stakedUsd"
    :poolRewardApy="poolRewardApy"
    :stakers="stakers"
    :totalRewardsInCgu="totalRewardsInCgu"
    :totalRewardsInUsd="totalRewardsInUsd"
  />
  <Benefits/>
  <WeeklyRewards
    :rewards="rewards"
    :rewardFormatted="rewardFormatted"
  />
  <!--   <timer /> -->
  <CguToken/>
  <!--  <Projects/>-->
  <!--  <Subscribe/>-->
  <!--  <partners />-->
  <Faq/>
</div>
<FooterBlock/>
